var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.pointList),function(point){return [_c('CampaignModalPageGeoMapMarker',{key:point.id,attrs:{"point":point,"is-active":_vm.isActive(point)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }